onDomReady(async function() {
   const videoElements = $$('video.video-js');

   if (videoElements.length == 0) {
      return;
   }

   await import('Shared/video-js-setup.js');

   // Initialize every video element in the page.
   videoElements.each(initializeVideoElement);
});

function initializeVideoElement(video) {
   if (video.getChildren('source').length === 0) {
      // if no source is available yet, show a processing icon
      var parent = video.getParent('.js-step-main-media');
      if (parent) {
         // replace the <video> with a <img> so that it maintains
         // the correct height after removing the video element
         parent.grab(
            new Element('img.vjs-processing-poster', {
               src: video.getAttribute('poster'),
            })
         );
         parent.grab(new Element('div.processingIcon'));
         parent.addClass('videoProcessing');
         video.destroy();
      }

      return;
   }

   // only our mp4s are available in multiple resolutions, so don't bother
   // displaying a resolution switcher if the browser doesn't support mp4
   var useResolutionSwitcher = video.canPlayType('video/mp4') !== '';
   var initialResolution = guessResolution(video) || { res: 'low' };

   var width = video.getProperty('width');
   var height = video.getProperty('height');

   var options = {
      // Do not change 'preload' to 'metadata' or 'auto'. If there are too
      // many videos on one page, Chrome will open the max number of
      // simultaneous connections to the s3 domain, and none of the videos
      // will load.
      preload: 'none',
      loop: false,
      bigPlayButton: true,
      controlBar: {
         children: [
            'playToggle',
            'muteToggle',
            'progressControl',
            'fullscreenToggle',
            'restartControl',
         ],
      },
      width: width,
      height: height,

      // Ideally 'fluid' would be true, but since we display other types of
      // videos (iframes) in the same type of container, it's more
      // consistent to set the aspect ratio with padding-bottom on the
      // .videoBox element.
      fluid: false,
      plugins: !useResolutionSwitcher
         ? {}
         : {
              videoJsResolutionSwitcher: {
                 default: initialResolution.res,
              },
           },
   };

   var player = videojs(video, options);

   // if the width of the video player changes while it's active, then
   // check if there is a different optimal resolution.
   if (useResolutionSwitcher) {
      var checkResolutionLastWidth = 0;
      var checkResolution = Utils.rateLimiter(1000, function() {
         var parent = video.getParent();
         if (parent) {
            var currentWidth = Math.floor(parent.getSize().x);
            if (checkResolutionLastWidth !== currentWidth) {
               checkResolutionLastWidth = currentWidth;
               var newResolution = guessResolution(video);
               if (newResolution) {
                  player.currentResolution(newResolution.label);
               }
            }
         }
      });

      player.on('useractive', checkResolution);
      player.on('timeupdate', checkResolution);

      // stop automatically changing the resolution if the user manually
      // changes it once
      player.one('userresolutionchange', function() {
         player.off('useractive', checkResolution);
         player.off('timeupdate', checkResolution);
      });
   }

   // mute and start looping after playback ends
   // (the loop option doesn't trigger an ended event, so we can't mute it)
   player.on('ended', function() {
      player.muted(true);
      // the flash player version can't start playing from within the ended
      // event, so wait to call it.
      setTimeout(function() {
         player.play();
      }, 0);
   });

   var playButton = player.el().getElement('.vjs-big-play-button');

   var registerKeyBindings = function(ev) {
      // We should only be capturing the event if the target tagname is
      // the body
      if (ev.key === 'space' && ev.target.tagName === 'BODY') {
         if (player.paused()) {
            player.play();
         } else {
            player.pause();
         }
         ev.preventDefault();
      }
   };

   // Only do this stuff if the player actually becomes "ready"
   player.ready(function() {
      if (typeof ScrollSpy === 'undefined') {
         return;
      }

      // Initialize scroll listener
      var ss = new ScrollSpy({
         target: [player.el()],
         onEnter: function(position, item, count) {
            window.addEvent('keydown', registerKeyBindings);
            // only show the play/pause toggle if the player is currently
            // paused. It's really annoying having the video play and then
            // moving the screen while your watching and having the button
            // interfere
            if (player.paused()) {
               playButton.style.opacity = '1';
            }
         },
         onLeave: function(position, item, count) {
            window.removeEvent('keydown', registerKeyBindings);
            // if the player leaves the view window, pause the video
            if (!player.paused()) {
               player.pause();
            }

            playButton.style.opacity = '0';
         },
      });
   });
}

// gets the smallest resolution available larger than the player width
function guessResolution(video, targetWidth) {
   targetWidth = targetWidth || video.getParent().getSize().x;

   // get all mp4 resolutions available in a sorted array
   var resolutionsAvailable = video
      .getChildren('source[type=video/mp4][label][res]')
      .getProperties('label', 'res')
      .sort(function(a, b) {
         return +a.res - +b.res;
      });

   // get the resolutions available larger than the player width
   var largerResolutions = Array.filter(resolutionsAvailable, function(src) {
      return +src.res > targetWidth;
   });

   var newResolution = null;

   // pick the smallest one larger than the player width, or if that
   // isn't available, just pick the largest one, or return null
   // if no resolutions are available.
   if (largerResolutions.length > 0) {
      newResolution = largerResolutions[0];
   } else if (resolutionsAvailable.length > 0) {
      newResolution = resolutionsAvailable.last();
   }

   return newResolution;
}
